import { FunctionComponent } from 'react';
import { View, Text, RupeeSymbol, ContainedIcon, Tag } from '@upstox/upstox-ui';
import * as css from './IPOHeader.style';
import useCurrentWidth from '../../../hooks/useCurrentWidth';

type Props = {
  ipoIcon: string;
  ipoName: string;
  ipoSymbol: string;
  minPrice: number;
  maxPrice: number;
  status: string;
  logoMeta?: { alt?: string; title?: string };
  tagColor?: TagColors;
};

const IPOHeader: FunctionComponent<Props> = ({
  ipoIcon,
  ipoName,
  ipoSymbol,
  minPrice,
  maxPrice,
  status,
  tagColor,
  logoMeta,
}) => {
  const screenWidth = useCurrentWidth();
  return (
    <View
      justifyContent="space-between"
      flexWrap="wrap"
      css={css.ipoHeader}
      id="ipoHeader"
    >
      <View alignItems="center" css={css.ipoName}>
        <View css={css.ipoLogo}>
          <ContainedIcon
            variant="primary"
            style={{ borderRadius: '50%', overflow: 'hidden' }}
          >
            <img
              src={ipoIcon}
              alt={logoMeta?.alt || ''}
              style={{ maxWidth: '100%' }}
              title={logoMeta?.title || ''}
            />
          </ContainedIcon>
        </View>
        <View flexDirection="column">
          <View css={css.ipoText}>
            <Text
              as="h1"
              variant={
                !screenWidth || screenWidth > 768 ? 'heading2' : 'bodyBold'
              }
            >
              {ipoName}
            </Text>
          </View>
          <View alignItems="center">
            <Text color="text.2" weight="metaBold">
              {ipoSymbol}
            </Text>
            {status && (
              <View margin={[0, 0, 0, 8]}>
                <Tag variant={tagColor} transform="none" size="small">
                  {status}
                </Tag>
              </View>
            )}
          </View>
        </View>
      </View>
      <View>
        <View alignItems="baseline">
          <Text
            variant="heading2"
            size={!screenWidth && screenWidth > 768 ? 'l' : 'xl'}
          >
            <RupeeSymbol
              size={!screenWidth && screenWidth > 768 ? 'l' : 'xl'}
              color="text.1"
              weight={!screenWidth && screenWidth > 768 ? 'bold' : 'body'}
              style={{ marginRight: 4 }}
            />
            {maxPrice && minPrice ? `${minPrice}-${maxPrice}` : '-'}
          </Text>
          <View css={css.subText}>
            <Text color="text.2">per share</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default IPOHeader;
